import { render } from "./PropertyCreateRega.vue?vue&type=template&id=5b32855f"
import script from "./PropertyCreateRega.vue?vue&type=script&lang=js"
export * from "./PropertyCreateRega.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__